// @flow

import type { FetchIdCollection } from './types/FetchIdCollection';
import type { RecentlyVisitedProduct } from '../../components/types/Product';
import type { Session } from '../../components/types/Session';

export default class RecentlyVisitedProductsCollection implements FetchIdCollection {
  maximumItems = 5;

  /**
   * @inheritDoc
   */
  fetch(): string[] {
    const sessions: Session[] = window.store.sessionManager.sessions;
    const products: RecentlyVisitedProduct[] = [];

    for (let i = 0; i < sessions.length; i++) {
      const possibleProducts: RecentlyVisitedProduct[] = sessions[i].recentlyVisitedProducts
        .sort((product: RecentlyVisitedProduct, comparison: RecentlyVisitedProduct) => {
          if (product.amount < comparison.amount) return 1;
          if (product.amount > comparison.amount) return -1;

          if (product.lastSeen.valueOf() < comparison.lastSeen.valueOf()) return 1;
          if (product.lastSeen.valueOf() > comparison.lastSeen.valueOf()) return -1;

          return undefined;
        })
        .map((product: RecentlyVisitedProduct) => product.id)
        .filter((id: string[]) => !products.includes(id));

      const maximumItemsToAdd = this.maximumItems - products.length;

      products.push(...possibleProducts.slice(0, maximumItemsToAdd));

      if (products.length >= this.maximumItems) break;
    }

    return products;
  }
}
